var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCellSpreader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 77,
    viewBox: "0 -15 23 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4928 1.14746C12.0958 1.14746 12.5847 1.61459 12.5847 2.19082L12.5847 58.4614L22.8394 75.4347C23.0344 75.7576 23.0344 76.1553 22.8394 76.4781C22.6444 76.8009 22.2839 76.9998 21.8939 76.9998H1.09182C0.701753 76.9998 0.341312 76.8009 0.146277 76.4781C-0.048759 76.1553 -0.0487589 75.7576 0.146277 75.4347L10.401 58.4614L10.401 2.19082C10.401 1.61459 10.8898 1.14746 11.4928 1.14746ZM11.4928 60.8277L2.98292 74.9131H20.0028L11.4928 60.8277Z",
    fill: "#FAAC48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.602 58.741V1.14746C12.0388 1.14746 12.5847 1.56481 12.5847 2.08649V58.5323C12.5847 58.5323 22.4111 74.7044 22.8478 75.4347C23.2846 76.1651 22.7386 76.9998 21.756 76.9998H1.01135C2.10318 76.9998 2.32154 76.2694 2.43072 76.1651L18.6584 75.9937C20.2133 75.9773 21.1555 74.2704 20.3407 72.9459L11.602 58.741Z",
    fill: "#B97216"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9469 60.2017L11.4929 60.8277C8.65411 65.5923 3.08581 74.7044 2.97663 74.913C2.97663 74.7044 2.64908 74.287 2.32153 74.1827L10.9469 60.2017Z",
    fill: "#D98F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellSpreader);
export default __webpack_public_path__ + "static/media/cell-spreader.8aa95f97a5b8144c777dd2438ebcefee.svg";
export { ForwardRef as ReactComponent };